import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/concept-attribute-type";

export const getAllConceptAttributeType = () => axios.get(API_PATH + "/getAll");

export const pagingConceptAttributeType = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getConceptAttributeTypeById = (conceptAttributeTypeId) => axios.get(API_PATH + "/getbyid/" + conceptAttributeTypeId);

export const saveConceptAttributeType = conceptAttributeType => axios.post(API_PATH + "/save", conceptAttributeType);

export const deleteConceptAttributeType = conceptAttributeTypeId => axios.delete(API_PATH + '/mark-delete/' + conceptAttributeTypeId)
